import { isAxiosError } from "axios";

interface ApiErrorResponse {
	message?: string;
}

export const getApiUrl = (): string => {
	const url =
		(typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) ||
		process.env.NEXT_PUBLIC_PRACTIUM_API_URL ||
		process.env.VITE_API_URL ||
		'';
	return url.endsWith('/') ? url : `${url}/`;
};

export const getApiErrorMessage = (error: unknown, fallback = 'Erro inesperado') => {
	if (isAxiosError<ApiErrorResponse>(error)) {
		if (error.response?.status === 429) {
			return 'Muitas chamadas foram feitas. Aguarde 1 minuto e tente novamente';
		}

		return error.response?.data?.message ?? fallback;
	}

	return error instanceof Error ? error.message : fallback;
};

export const toApiError = (error: unknown, fallback?: string) =>
	new Error(getApiErrorMessage(error, fallback));
